import { render, staticRenderFns } from "./AddSite.vue?vue&type=template&id=060dd34c&scoped=true"
import script from "./AddSite.vue?vue&type=script&lang=js"
export * from "./AddSite.vue?vue&type=script&lang=js"
import style0 from "./AddSite.vue?vue&type=style&index=0&id=060dd34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060dd34c",
  null
  
)

export default component.exports